__turbopack_context__.v({
  "optional": "FieldsetLabel-module-scss-module__O0EWwG__optional",
  "required": "FieldsetLabel-module-scss-module__O0EWwG__required",
  "text": "FieldsetLabel-module-scss-module__O0EWwG__text",
  "wrapper": "FieldsetLabel-module-scss-module__O0EWwG__wrapper",
});
